module.exports = __webpack_public_path__ + "img/CliAcneSet1.61330929.jpg";